__turbopack_context__.v({
  "breadcrumb": "Breadcrumbs-module___vBoEa__breadcrumb",
  "current": "Breadcrumbs-module___vBoEa__current",
  "disabledLink": "Breadcrumbs-module___vBoEa__disabledLink",
  "item": "Breadcrumbs-module___vBoEa__item",
  "link": "Breadcrumbs-module___vBoEa__link",
  "separator": "Breadcrumbs-module___vBoEa__separator",
});
